export const childSize = {
  small: 'small',
  medium: 'medium',
};

export const childWidthRange = {
  small: { from: 18, to: 47 },
  medium: { from: 48, to: 9999 },
};
